(function () {
  var CATEGORIES = [
    { name: 'Air Conduction', handle: 'air-conduction-headphones', url: '/collections/air-conduction-headphones', img: 'https://cdn.shopify.com/s/files/1/0804/5762/9975/files/black-open-ear-wireless-headphones-neckband-front.webp?v=1758523892' },
    { name: 'Bone Conduction', handle: 'bone-conduction-headphones', url: '/collections/bone-conduction-headphones', img: 'https://cdn.shopify.com/s/files/1/0804/5762/9975/files/Pro-back-Listing-image-1.jpg?v=1737747046' },
    { name: 'Wearables', handle: 'wearables', url: '/collections/wearables', img: 'https://cdn.shopify.com/s/files/1/0804/5762/9975/files/1_871bd641-0f95-4a60-a8ab-72d1ae4faad4.webp?v=1787561043' },
    { name: 'Beauty Tech', handle: 'beauty-tech', url: '/collections/beauty-tech', img: 'https://cdn.shopify.com/s/files/1/0804/5762/9975/files/Hcec8c8f14e214f74ae949c1e99ef63d9h.jpg_960x960q80.jpg?v=1787768741' },
    { name: 'Projectors', handle: 'projectors', url: '/collections/projectors', img: 'https://cdn.shopify.com/s/files/1/0804/5762/9975/files/nova-studio.png?v=1793789635&width=200' },
    { name: 'Mobile Accessories', handle: 'mobile-accessories', url: '/collections/mobile-accessories', img: 'https://cdn.shopify.com/s/files/1/0804/5762/9975/files/takit1.webp?v=1787842711' },
    { name: 'Official Accessories', handle: 'official-accessories', url: '/collections/official-accessories', img: 'https://cdn.shopify.com/s/files/1/0804/5762/9975/files/procable2.jpg?v=1761980886' }
  ];

  function fetchCategoryProducts(cat) {
    return fetch('/collections/' + cat.handle + '/products.json?limit=250')
      .then(function (res) { return res.json(); })
      .then(function (data) { return (data && data.products) || []; })
      .catch(function () { return []; });
  }

  function buildProductRow(product) {
    var a = document.createElement('a');
    a.className = 'ng-mb-cats__prod';
    a.href = product.url || ('/products/' + product.handle);

    var thumb = document.createElement('span');
    thumb.className = 'ng-mb-cats__prod-img';
    var imgSrc = product.images && product.images[0] ? (product.images[0].src || product.images[0]) : (product.featured_image || '');
    if (imgSrc) {
      var img = document.createElement('img');
      img.src = imgSrc.indexOf('http') === 0 ? imgSrc.replace(/(\.[a-zA-Z]+)(\?|$)/, '_100x$1$2') : imgSrc;
      img.loading = 'lazy';
      img.alt = product.title || '';
      thumb.appendChild(img);
    }

    var name = document.createElement('span');
    name.className = 'ng-mb-cats__prod-name';
    name.textContent = product.title || '';

    a.appendChild(thumb);
    a.appendChild(name);

    if (product.available === false) {
      a.classList.add('is-oos');
      var badge = document.createElement('span');
      badge.className = 'ng-mb-cats__prod-oos';
      badge.textContent = 'Out of Stock';
      a.appendChild(badge);
    }

    return a;
  }

  function buildCategoryItem(cat, products) {
    var li = document.createElement('li');
    li.className = 'ng-mb-cats-cat t4s-menu-item t4s-item-level-0';

    var row = document.createElement('div');
    row.className = 'ng-mb-cats-cat__row';

    var link = document.createElement('a');
    link.className = 'ng-mb-cats-cat__link';
    link.href = cat.url;

    var thumbWrap = document.createElement('span');
    thumbWrap.className = 'ng-mb-cats-cat__thumb';
    if (cat.img) {
      var thumbImg = document.createElement('img');
      thumbImg.src = cat.img;
      thumbImg.loading = 'lazy';
      thumbImg.alt = cat.name;
      thumbWrap.appendChild(thumbImg);
    } else {
      thumbWrap.innerHTML = '<span class="ng-mb-cats-cat__thumb-ph">&#128717;</span>';
    }

    var label = document.createElement('span');
    label.className = 'ng-mb-cats-cat__name';
    label.textContent = cat.name;

    link.appendChild(thumbWrap);
    link.appendChild(label);

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'ng-mb-cats-cat__toggle';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Show ' + cat.name + ' products');
    toggle.innerHTML = '<span class="ng-mb-cats-cat__toggle-icon">+</span>';

    row.appendChild(link);
    row.appendChild(toggle);

    var panel = document.createElement('div');
    panel.className = 'ng-mb-cats-cat__panel';
    panel.hidden = true;

    var rendered = false;
    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      if (expanded) {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.querySelector('.ng-mb-cats-cat__toggle-icon').textContent = '+';
        panel.hidden = true;
        return;
      }
      toggle.setAttribute('aria-expanded', 'true');
      toggle.querySelector('.ng-mb-cats-cat__toggle-icon').textContent = '−';
      panel.hidden = false;

      if (rendered) return;
      rendered = true;
      products.forEach(function (p) {
        panel.appendChild(buildProductRow(p));
      });
      var viewAll = document.createElement('a');
      viewAll.className = 'ng-mb-cats-cat__viewall';
      viewAll.href = cat.url;
      viewAll.textContent = 'View all ' + cat.name;
      panel.appendChild(viewAll);
    });

    li.appendChild(row);
    li.appendChild(panel);
    return li;
  }

  function hideOldItems() {
    ['item_mb_nav-1', 'item_mb_nav-3', 'item_mb_sea'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.style.display = 'none';
    });
  }

  function init() {
    var ul = document.getElementById('menu-mb__ul');
    if (!ul || ul.dataset.ngCatsInjected) return false;
    ul.dataset.ngCatsInjected = '1';
    hideOldItems();

    var wrap = document.createElement('li');
    wrap.className = 'ng-mb-cats-item';

    var label = document.createElement('p');
    label.className = 'ng-mb-cats__label';
    label.textContent = 'Shop by Category';

    var list = document.createElement('div');
    list.className = 'ng-mb-cats-list';

    wrap.appendChild(label);
    wrap.appendChild(list);
    ul.insertBefore(wrap, ul.firstChild);

    Promise.all(
      CATEGORIES.map(function (cat) {
        return fetchCategoryProducts(cat).then(function (products) {
          return { cat: cat, products: products };
        });
      })
    ).then(function (results) {
      var anyVisible = false;
      results.forEach(function (r) {
        if (!r.products.length) return;
        anyVisible = true;
        list.appendChild(buildCategoryItem(r.cat, r.products));
      });
      if (!anyVisible) wrap.style.display = 'none';
    });

    return true;
  }

  if (init()) return;

  var observer = new MutationObserver(function () {
    if (init()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', init);
})();
